import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ContractRefundPaymentItem.Export.IRequest;
type Response = Api.Finance.ContractRefundPaymentItem.Export.IResponse;
type Headers = Api.Finance.ContractRefundPaymentItem.Export.IHeaders;
const url = '/api/Finance/ContractRefundPaymentItem/ExportToExcel';
export default async function contractRefundPaymentItemExportApi(query: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, null, { ...query, isExcluded: query?.isExcluded ?? undefined }),
    headers: getDefaultHeaders(),
  });
}
